<template>
    <div
        class="ppv2-flex ppv2-flex-col ppv2-space-y-1 ppv2-cursor-pointer"
        :class="[{ 'ppv2-opacity-60 ppv2-cursor-not-allowed': disabled }, classAdd]"
        @click="toggle"
    >
        <div class="ppv2-flex ppv2-items-center" :class="label ? 'ppv2-space-x-2' : ''">
            <div class="ppv2-relative">
                <input type="checkbox" :disabled="disabled" :checked="internalValue" class="ppv2-sr-only" readonly />
                <div
                    :class="[
                        'ppv2-rounded ppv2-border ppv2-transition-all ppv2-ease-in-out',
                        sizeClass,
                        // Gestion de la bordure
                        error
                            ? 'ppv2-border-red-500'
                            : hasBorderChecked
                              ? 'ppv2-border-black'
                              : internalValue
                                ? 'ppv2-border-none'
                                : 'ppv2-border-black',
                        disabled ? 'ppv2-bg-gray-100 ppv2-border-gray-300' : '',
                        !disabled
                            ? 'ppv2-hover:border-primary-500 ppv2-focus:ring-2 ppv2-focus:ring-primary-500 ppv2-focus:ring-opacity-50'
                            : '',
                    ]"
                >
                    <Check
                        v-if="internalValue"
                        class="ppv2-absolute ppv2-top-1/2 ppv2-left-1/2 ppv2-w-3 ppv2-h-3 ppv2-text-black ppv2-transform ppv2--translate-x-1/2 ppv2--translate-y-1/2"
                    />
                </div>
            </div>
            <span class="ppv2-text-black ppv2-text-sm" :style="normalizeSize(14, true)">{{ label }}</span>
        </div>

        <p v-if="description" class="ppv2-ml-6 ppv2-text-xs ppv2-text-white">
            {{ description }}
        </p>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import { Check } from 'lucide-vue'
export default {
    name: 'BaseCheckbox',
    components: { Check },
    props: {
        hasBorderChecked: {
            type: Boolean,
            default: true,
        },
        value: {
            type: [Boolean, String, Number],
            default: false,
        },
        classAdd: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        disabled: Boolean,
        error: String,
        size: {
            type: String,
            default: 'md',
            validator: (val) => ['sm', 'md', 'lg', 'xs'].includes(val),
        },
    },
    data() {
        return {
            internalValue: Boolean(this.value),
        }
    },
    watch: {
        value(val) {
            this.internalValue = val
        },
    },
    computed: {
        sizeClass() {
            switch (this.size) {
                case 'xs':
                    return 'ppv2-w-[12px] ppv2-h-[12px]'
                case 'sm':
                    return 'ppv2-w-[14px] ppv2-h-[14px]'
                case 'lg':
                    return 'ppv2-w-[22px] ppv2-h-[22px]'
                default:
                    return 'ppv2-w-[18px] ppv2-h-[18px]'
            }
        },
    },
    methods: {
        normalizeSize,
        toggle() {
            if (this.disabled) return
            this.internalValue = !this.internalValue
            this.$emit('input', this.internalValue)
        },
    },
}
</script>
